const roleAccess = {
  1: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings'],
  2: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings'],
  3: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings'],
  4: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings'],
  5: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings'],
  6: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings'],
  7: ['dashboard', 'orders', 'customers', 'products', 'shipping', 'payments', 'invoices', 'reports', 'settings']
};

const menu = [
  {
    key: 'dashboard',
    name: 'dashboard',
    icon: 'DashboardOutlined',
    label: 'Dashboard',
    children: [
      { key: '/dashboard/overview', label: 'Overview' },
      { key: '/dashboard/recent-orders', label: 'Recent Orders' },
      { key: '/dashboard/sales-summary', label: 'Sales Summary' }
    ]
  },
  {
    key: 'orders',
    name: 'orders',
    icon: 'OrdersOutlined',
    label: 'Orders',
    children: [
      { key: '/orders/all', label: 'All Orders' },
      { key: '/orders/pending', label: 'Pending Orders' },
      { key: '/orders/processing', label: 'Processing Orders' },
      { key: '/orders/shipped', label: 'Shipped Orders' },
      { key: '/orders/delivered', label: 'Delivered Orders' },
      { key: '/orders/cancelled', label: 'Cancelled Orders' },
      { key: '/orders/returned', label: 'Returned / Refunded Orders' }
    ]
  },
  {
    key: 'customers',
    name: 'customers',
    icon: 'ClientsOutlined',
    label: 'Customers',
    children: [
      { key: '/customers/list', label: 'Customer List' },
      { key: '/customers/segments', label: 'Customer Segments' },
      { key: '/customers/history', label: 'Order History' }
    ]
  },
  {
    key: 'products',
    name: 'products',
    icon: 'InventoryOutlined',
    label: 'Products',
    children: [
      { key: '/products/catalog', label: 'Product Catalog' },
      { key: '/products/inventory', label: 'Inventory Status' },
      { key: '/products/out-of-stock', label: 'Out of Stock Alerts' }
    ]
  },
  {
    key: 'shipping',
    name: 'shipping',
    icon: 'ShippingOutlined',
    label: 'Shipping',
    children: [
      { key: '/shipping/providers', label: 'Shipping Providers' },
      { key: '/shipping/status', label: 'Shipping Status' },
      { key: '/shipping/track', label: 'Track Shipments' }
    ]
  },
  {
    key: 'invoices',
    name: 'invoices',
    icon: 'PayslipOutlined',
    label: 'Invoices',
    children: [
      { key: '/documents/generate', label: 'Generate Invoices' },
      { key: '/documents/print', label: 'Print / Download' },
      { key: '/documents/receipts', label: 'Order Receipts' }
    ]
  },
  {
    key: 'reports',
    name: 'reports',
    icon: 'ReportsOutlined',
    label: 'Reports',
    children: [
      { key: '/reports/sales', label: 'Sales Reports' },
      { key: '/reports/order-trends', label: 'Order Trends' },
      { key: '/reports/cancellations', label: 'Cancellations / Returns' }
    ]
  },
  {
    key: 'settings',
    name: 'settings',
    icon: 'SettingsOutlined',
    label: 'Settings',
    children: [
      { key: '/settings/order', label: 'Order Settings' },
      { key: '/settings/notifications', label: 'Notification Preferences' },
      { key: '/settings/templates', label: 'Invoice/Document Templates' }
    ]
  }
];


function getWorkflowMenuForRoles(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const accessibleItems = roleAccess[roleId] || [];
    accessibleItems?.forEach(item => accessibleMenus.add(item));
  });
  return menu.filter(menuItem => accessibleMenus.has(menuItem.name));
}


const developmentroleAccess = {
  1: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  2: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  3: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  4: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  5: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  6: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  7: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  8: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment'],
  9: ['Dashboard', "Milestone", "Calendar", 'Scrum', 'Epic', 'Tickets', 'Sprints', 'Retrospectives', 'Backlog', 'Components', 'Modules', 'Services', 'Test Cases', 'Release', 'Project Files', 'Monitoring', 'API Platform' ,'Environment']
};

const supportRoleAccess = {
  1: ['Dashboard', 'Tickets', 'Calendar', 'Agents', 'Customers', 'Knowledge Base', 'SLA Reports', 'Escalations', 'Analytics', 'Settings'],
  2: ['Dashboard', 'Tickets', 'Calendar', 'Agents', 'Customers', 'Knowledge Base', 'SLA Reports', 'Escalations', 'Analytics', 'Settings'],
  3: ['Dashboard', 'Tickets', 'Knowledge Base', 'Analytics'],
  4: ['Dashboard', 'Tickets', 'Calendar', 'Knowledge Base', 'Escalations', 'Analytics'],
  5: ['Dashboard', 'Tickets', 'Calendar', 'Knowledge Base', 'Analytics'],
  6: ['Dashboard', 'Tickets', 'Knowledge Base'],
  7: ['Dashboard', 'Tickets', 'Knowledge Base', 'Analytics']
};

const salesRoleAccess = {
  1: ['Dashboard', 'Leads', 'Prospects', 'Opportunities', 'Pipeline', 'Accounts', 'Activities', 'Campaigns', 'Reports', 'Settings'],
  2: ['Dashboard', 'Leads', 'Prospects', 'Opportunities', 'Pipeline', 'Accounts', 'Activities', 'Campaigns', 'Reports'],
  3: ['Dashboard', 'Leads', 'Opportunities', 'Pipeline', 'Reports'],
  4: ['Dashboard', 'Leads', 'Prospects', 'Opportunities', 'Reports'],
  5: ['Dashboard', 'Leads', 'Pipeline', 'Reports'],
  6: ['Dashboard', 'Leads', 'Opportunities'],
  7: ['Dashboard', 'Leads', 'Opportunities', 'Reports']
};

const marketingRoleAccess = {
  1: ['Dashboard', 'Campaigns', 'Projects', 'Content', 'Calendar', 'Leads', 'Emails', 'Automation', 'Analytics', 'Settings'],
  2: ['Dashboard', 'Campaigns', 'Projects', 'Content', 'Calendar', 'Emails', 'Analytics'],
  3: ['Dashboard', 'Campaigns', 'Content', 'Emails', 'Analytics'],
  4: ['Dashboard', 'Campaigns', 'Calendar', 'Automation', 'Analytics'],
  5: ['Dashboard', 'Campaigns', 'Projects', 'Emails'],
  6: ['Dashboard', 'Campaigns', 'Content'],
  7: ['Dashboard', 'Campaigns', 'Emails', 'Analytics']
};

const financeRoleAccess = {
  1: ['Dashboard', 'Budgets', 'Requests', 'Approvals', 'Transactions', 'Invoices', 'Expenses', 'Reports', 'Audit Logs', 'Settings'],
  2: ['Dashboard', 'Budgets', 'Requests', 'Approvals', 'Transactions', 'Invoices', 'Reports', 'Audit Logs'],
  3: ['Dashboard', 'Budgets', 'Requests', 'Reports'],
  4: ['Dashboard', 'Budgets', 'Requests', 'Approvals', 'Reports'],
  5: ['Dashboard', 'Budgets', 'Requests', 'Reports'],
  6: ['Dashboard', 'Requests', 'Invoices', 'Expenses'],
  7: ['Dashboard', 'Budgets', 'Reports']
};


const hrRoleAccess = {
  1: ['Dashboard', 'Employees', 'Recruitment', 'Requests', 'Attendance', 'Leaves', 'Performance', 'Payroll', 'Policies', 'Settings'],
  2: ['Dashboard', 'Employees', 'Recruitment', 'Requests', 'Attendance', 'Leaves', 'Performance', 'Policies'],
  3: ['Dashboard', 'Employees', 'Requests', 'Leaves', 'Performance', 'Policies'],
  4: ['Dashboard', 'Employees', 'Recruitment', 'Performance', 'Payroll'],
  5: ['Dashboard', 'Employees', 'Attendance', 'Leaves', 'Performance'],
  6: ['Dashboard', 'Requests', 'Leaves', 'Policies'],
  7: ['Dashboard', 'Performance', 'Policies']
};

const assetsRoleAccess = {
  1: ['Dashboard', 'Asset Register', 'Assignments', 'Tracking', 'Maintenance', 'Depreciation', 'Warranty', 'Disposals', 'Audit Logs', 'Settings'],
  2: ['Dashboard', 'Asset Register', 'Assignments', 'Tracking', 'Maintenance', 'Depreciation', 'Warranty', 'Disposals', 'Audit Logs'],
  3: ['Dashboard', 'Asset Register', 'Tracking', 'Maintenance', 'Disposals'],
  4: ['Dashboard', 'Asset Register', 'Assignments', 'Maintenance', 'Audit Logs'],
  5: ['Dashboard', 'Asset Register', 'Tracking', 'Warranty'],
  6: ['Dashboard', 'Tracking', 'Maintenance'],
  7: ['Dashboard', 'Asset Register', 'Tracking']
};

const helpdeskRoleAccess = {
  1: ['Dashboard', 'Tickets', 'Calendar', 'SLA Reports', 'Agents', 'Customers', 'Knowledge Base', 'Escalations', 'Analytics', 'Settings'],
  2: ['Dashboard', 'Tickets', 'Calendar', 'SLA Reports', 'Agents', 'Customers', 'Knowledge Base', 'Escalations', 'Analytics'],
  3: ['Dashboard', 'Tickets', 'Knowledge Base', 'Analytics'],
  4: ['Dashboard', 'Tickets', 'Calendar', 'Knowledge Base', 'Escalations', 'Analytics'],
  5: ['Dashboard', 'Tickets', 'Calendar', 'Knowledge Base', 'Analytics'],
  6: ['Dashboard', 'Tickets', 'Knowledge Base'],
  7: ['Dashboard', 'Tickets', 'Knowledge Base', 'Analytics']
};

const development = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Milestone', key: 'Milestone', icon: 'EventsOutlined' },
  { label: 'Calendar', key: 'calendar', icon: 'CalendarOutlined' },
  { label: 'Scrum', key: 'scrum', icon: 'ScrumSprintOutlined' },
  { label: 'Epic', key: 'epic', icon: 'EpicOutlined' },
  { label: 'Tickets', key: 'tickets', icon: 'IssuesOutlined' },
  { label: 'Sprints', key: 'sprints', icon: 'ActiveSprintOutlined' },
  {label: 'Retrospectives', key: 'retrospectives', icon: 'RefreshOutlined' },
  { label: 'Backlog', key: 'backlog', icon: 'BackLogOutlined' },
  { label: 'Components', key: 'components', icon: 'ComponentsOutlined' },
  { label: 'Modules', key: 'modules', icon: 'ModulesOutlined' },
  { label: 'Services', key: 'services', icon: 'WebOutlined' },
  {label: 'Test Cases', key: 'testcases', icon: 'TestCasesOutlined' },
  // { label: 'Release', key: 'release', icon: 'DeploymentOutlined' },
  { label: 'Project Files', key: 'drive', icon: 'FileOutlined' }
  // { label: 'Environment', key: 'environment', icon: 'EnvironmentOutlined' },
  // { label: 'Monitoring', key: 'monitoring', icon: 'MonitoringOutlined' },
  // { label: 'API Platform', key: 'apiplatform', icon: 'MonitoringOutlined' }
];

const helpdesk = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Tickets', key: 'tickets', icon: 'IssuesOutlined' },
  { label: 'Calendar', key: 'calendar', icon: 'CalendarOutlined' },
  { label: 'SLA Reports', key: 'slaReports', icon: 'Qualified' },
  { label: 'Agents', key: 'agents', icon: 'SupportPortalOutlined' },
  { label: 'Customers', key: 'customers', icon: 'DepartmentOutlined' },
  { label: 'Knowledge Base', key: 'knowledgebase', icon: 'KnowledgebaseOutlined' },
  { label: 'Escalations', key: 'escalations', icon: 'EscalationOutlined' },
  { label: 'Analytics', key: 'analytics', icon: 'ReportsOutlined' },
  { label: 'Settings', key: 'settings', icon: 'SettingsOutlined' }

];

const support = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Tickets', key: 'tickets', icon: 'IssuesOutlined' },
  { label: 'Calendar', key: 'calendar', icon: 'CalendarOutlined' },
  { label: 'Agents', key: 'agents', icon: 'SupportPortalOutlined' },
  { label: 'Customers', key: 'customers', icon: 'DepartmentOutlined' },
  { label: 'Knowledge Base', key: 'knowledgebase', icon: 'BookOutlined' },
  { label: 'SLA Reports', key: 'slaReports', icon: 'Qualified' },
  { label: 'Escalations', key: 'escalations', icon: 'EscalationOutlined' },
  { label: 'Analytics', key: 'analytics', icon: 'TrackOutlined' },
  { label: 'Settings', key: 'settings', icon: 'SettingsOutlined' }
];

const sales = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Leads', key: 'leads', icon: 'SalesOutlined' },
  { label: 'Prospects', key: 'prospects', icon: 'TickOutlined' },
  { label: 'Opportunities', key: 'opportunities', icon: 'ActivateOutlined' },
  { label: 'Pipeline', key: 'pipeline', icon: 'PipeOutlinedLogo' },
  { label: 'Accounts', key: 'accounts', icon: 'ActiveUseresOutlined' },
  { label: 'Activities', key: 'activities', icon: 'ActivityOutlined' },
  { label: 'Campaigns', key: 'campaigns', icon: 'AnnouncementsOutlined' },
  { label: 'Reports', key: 'reports', icon: 'Qualified' },
  { label: 'Settings', key: 'settings', icon: 'SettingsOutlined' }
];


const marketing = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Campaigns', key: 'campaigns', icon: 'AnnouncementsOutlined' },
  { label: 'Projects', key: 'projects', icon: 'FolderLine' },
  { label: 'Content', key: 'content', icon: 'EstimatesOutlined' },
  { label: 'Calendar', key: 'calendar', icon: 'CalendarOutlined' },
  { label: 'Leads', key: 'leads', icon: 'ActiveUseresOutlined' },
  { label: 'Emails', key: 'emails', icon: 'EmailOutlined' },
  { label: 'Automation', key: 'automation', icon: 'RefreshOutlined' },
  { label: 'Analytics', key: 'analytics', icon: 'ReportsOutlined' },
  { label: 'Settings', key: 'settings', icon: 'SettingsOutlined' }
];

const finance = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Budgets', key: 'budgets', icon: 'InvoicesOutlined' },
  { label: 'Requests', key: 'requests', icon: 'ResuestOutlined' },
  { label: 'Approvals', key: 'approvals', icon: 'TestCasesOutlined' },
  { label: 'Bills', key: 'bills', icon: 'InvoicesOutlined' },
  { label: 'Invoices', key: 'invoices', icon: 'InvoicesOutlined' },
  { label: 'Claims', key: 'claims', icon: 'ClaimsOutlined' },
  { label: 'Estimates', key: 'estimates', icon: 'EstimatesOutlined' },
  { label: 'Expenses', key: 'expenses', icon: 'ExpensesOutlined' },
  { label: 'Settings', key: 'settings', icon: 'SettingsOutlined' }
];

const hr = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Employees', key: 'employees', icon: 'Revenueperemployee' },
  { label: 'Recruitment', key: 'recruitment', icon: 'RecuritmentOutlined' },
  { label: 'Requests', key: 'requests', icon: 'ClientsOutlined' },
  { label: 'Attendance', key: 'attendance', icon: 'CalendarOutlined' },
  { label: 'Leaves', key: 'leaves', icon: 'Deptutilization' },
  { label: 'Performance', key: 'performance', icon: 'StarOutlined' },
  { label: 'Payroll', key: 'payroll', icon: 'ExpensesOutlined' },
  { label: 'Policies', key: 'policies', icon: 'BillsOutlined' },
  { label: 'Settings', key: 'settings', icon: 'SettingsOutlined' }
];


const eventsAccess = {
  1: ['Dashboard', 'Events', 'Drafts', 'Upcoming', 'Completed', 'Meetings', 'Contacts'],
  2: ['Dashboard', 'Events', 'Drafts', 'Upcoming', 'Completed', 'Meetings', 'Contacts'],
  3: ['Dashboard', 'Events', 'Drafts', 'Upcoming', 'Completed', 'Meetings', 'Contacts'],
  5: ['Dashboard', 'Events', 'Drafts', 'Upcoming', 'Completed', 'Meetings', 'Contacts'],
  6: ['Dashboard', 'Events', 'Drafts', 'Upcoming', 'Completed', 'Meetings', 'Contacts'],
  7: ['Dashboard', 'Events', 'Drafts', 'Upcoming', 'Completed', 'Meetings', 'Contacts']
};

const events = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Events', key: 'events', icon: 'AddtoGroupsOutlined' },
  { label: 'Drafts', key: 'drafts', icon: 'EditOutlined' },
  { label: 'Upcoming', key: 'upcoming', icon: 'MeetingsOutlined' },
  { label: 'Completed', key: 'completed', icon: 'Chance' },
  { label: 'Meetings', key: 'meetings', icon: 'CalendarOutlined' },
  { label: 'Contacts', key: 'contacts', icon: 'AddressBookOutlined' }
];

const assets = [
  { label: 'Dashboard', key: 'dashboard', icon: 'DashboardOutlined' },
  { label: 'Asset Register', key: 'register', icon: 'DatabaseOutlined' },
  { label: 'Assignments', key: 'assignments', icon: 'UserSwitchOutlined' },
  { label: 'Tracking', key: 'tracking', icon: 'AimOutlined' },
  { label: 'Maintenance', key: 'maintenance', icon: 'ToolOutlined' },
  { label: 'Depreciation', key: 'depreciation', icon: 'LineChartOutlined' },
  { label: 'Warranty', key: 'warranty', icon: 'SafetyCertificateOutlined' },
  { label: 'Disposals', key: 'disposals', icon: 'DeleteOutlined' },
  { label: 'Audit Logs', key: 'auditlogs', icon: 'FileSearchOutlined' },
  { label: 'Settings', key: 'settings', icon: 'SettingOutlined' }
];

let common = [
  // { label: 'Polls', key: 'polls', icon: 'PollOutlined' }
];

function appendCommon(menuList) {
  const existingKeys = new Set(menuList.map(m => m.key));
  return [
    ...menuList,
    ...common.filter(item => !existingKeys.has(item.key))
  ];
}



function getWorkflowDev(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = developmentroleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    development.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowHelpdesk(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = helpdeskRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    helpdesk.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowFinance(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = financeRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    finance.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowMarketing(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = marketingRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    marketing.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowHr(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = hrRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    hr.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowSales(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = salesRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    sales.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowSupport(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = supportRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    support.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowEvents(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = eventsAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    events.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}

function getWorkflowAsserts(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const items = assetsRoleAccess[roleId] || [];
    items.forEach(item => accessibleMenus.add(item));
  });
  return appendCommon(
    assets.filter(menuItem => accessibleMenus.has(menuItem.label))
  );
}



const templateMenuGenerators = {
  orders: getWorkflowMenuForRoles,
  sales: getWorkflowSales,
  hr: getWorkflowHr,
  marketing: getWorkflowMarketing,
  support: getWorkflowSupport,
  finance: getWorkflowFinance,
  helpDesk: getWorkflowHelpdesk,
  development: getWorkflowDev,
  events: getWorkflowEvents,
  assets: getWorkflowAsserts
};


export {
  templateMenuGenerators
};
